import { render, staticRenderFns } from "./sportsbookLayout.vue?vue&type=template&id=796452b2&"
import script from "./sportsbookLayout.vue?vue&type=script&lang=js&"
export * from "./sportsbookLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports